var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-field',{staticStyle:{"width":"100px"},attrs:{"select":"","field":{
        value: _vm.header.value,
        text: _vm.header.text,
        id: _vm.header.id,
        filter: _vm.header.filter,
        list: _vm.header.list,
        reference: _vm.header.reference,
        title: _vm.header.title,
        subtitle: _vm.header.subtitle,
        type: 'autocomplete',
        placeholder: 'Select',
        full: true,
    },"value":_vm.value},on:{"input":function (v) { return _vm.$emit('input', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }